import React from 'react';
import styled from 'styled-components';
import { Spin } from 'antd';
import { useFlexibleTranslation } from '../contexts/LanguageContext';

const FloatingOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.6);
  z-index: 9998;
`;

const FloatingModal = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: white;
  border-radius: 12px;
  padding: 24px 32px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.2);
  display: flex;
  align-items: center;
  gap: 12px;
  z-index: 9999;
`;

const FloatingMessage = styled.div`
  font-size: 16px;
  color: #333;
`;

const FloatingUploadModal = ({ visible, message }) => {
  const { t } = useFlexibleTranslation();
  const defaultMessage = t('upload.uploadingFromGoogleDrive', 'Uploading from Google Drive...');
  
  if (!visible) return null;

  return (
    <>
      <FloatingOverlay />
      <FloatingModal>
        <Spin />
        <FloatingMessage>{message || defaultMessage}</FloatingMessage>
      </FloatingModal>
    </>
  );
};

export default FloatingUploadModal;
